import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface MobileDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const MobileDrawer: React.FC<MobileDrawerProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black/50 z-50"
            onClick={onClose}
          />
          
          {/* Drawer */}
          <motion.div
            initial={{ x: -300 }}
            animate={{ x: 0 }}
            exit={{ x: -300 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fixed top-0 left-0 w-80 h-full bg-slate-900/98 backdrop-blur-xl border-r border-slate-700/50 z-50 p-5"
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-8 pb-4 border-b border-slate-700/50">
              <h2 className="text-bible-gold text-xl font-semibold">Navigation</h2>
              <button
                onClick={onClose}
                className="text-bible-gold hover:text-yellow-300 text-2xl p-1 rounded transition-colors"
              >
                ×
              </button>
            </div>
            
            {/* Links */}
            <div className="space-y-3">
              <a
                href="/"
                onClick={onClose}
                className="flex items-center gap-3 p-3 rounded-lg border border-slate-700/50 text-slate-200 hover:bg-bible-gold/10 hover:text-bible-gold hover:border-bible-gold/30 transition-all duration-200 hover:translate-x-1"
              >
                <span className="text-lg">🏠</span>
                <span>Home</span>
              </a>
              
              <a
                href="/ai-generator"
                onClick={onClose}
                className="flex items-center gap-3 p-3 rounded-lg border border-slate-700/50 text-slate-200 hover:bg-bible-gold/10 hover:text-bible-gold hover:border-bible-gold/30 transition-all duration-200 hover:translate-x-1"
              >
                <span className="text-lg">✨</span>
                <span>Slideshow Generator</span>
              </a>
              
              <a
                href="/bible-studies/daniel/chapter7"
                onClick={onClose}
                className="flex items-center gap-3 p-3 rounded-lg border border-slate-700/50 text-slate-200 hover:bg-bible-gold/10 hover:text-bible-gold hover:border-bible-gold/30 transition-all duration-200 hover:translate-x-1"
              >
                <span className="text-lg">📖</span>
                <span>Daniel Chapter 7</span>
              </a>
              
              <a
                href="/about"
                onClick={onClose}
                className="flex items-center gap-3 p-3 rounded-lg border border-slate-700/50 text-slate-200 hover:bg-bible-gold/10 hover:text-bible-gold hover:border-bible-gold/30 transition-all duration-200 hover:translate-x-1"
              >
                <span className="text-lg">ℹ️</span>
                <span>About</span>
              </a>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default MobileDrawer
